﻿import {NamedValue, StringNamedValue} from "@2d-front-monorepo/core";
import {useMemo} from "react";

/**
 * Common entry shape for the option-based MVVM controls (single/multi, list/group).
 * Every optional field is forwarded by {@link useOptionItemMap}; individual controls
 * only surface the subset their underlying HTML control actually renders.
 */
export interface MvvmOptionEntry<TValue> extends NamedValue<TValue> {
	hint?: string;
	description?: string;
	descriptionOpen?: boolean;
	disabled?: boolean;
}

export interface MvvmMappedOption extends StringNamedValue {
	hint?: string;
	description?: string;
	descriptionOpen?: boolean;
	disabled?: boolean;
}

/**
 * Maps option entries to index-keyed entries (value = array index as string) the way every
 * option control needs. The index addressing is what lets the selection hooks translate the
 * control's `number[]` change events back into the original `TValue`s.
 */
export function useOptionItemMap<TValue>(items: MvvmOptionEntry<TValue>[]): MvvmMappedOption[] {
	return useMemo<MvvmMappedOption[]>(() => items.map((x, index) => ({
		value: index.toString(),
		label: x.label,
		hint: x.hint,
		description: x.description,
		descriptionOpen: x.descriptionOpen,
		disabled: x.disabled
	})), [items]);
}
